/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:38
 */
import { Post, Get, Patch, Put, Delete, Download, ax, Import } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace AppointmentTime {
    /**
     *  时间窗口设置列表
     */
    export var GetTimeWDList = (query: any): Promise<any> => {
        return Get(`/msls/AppointmentTime/GetList?${qs.stringify(query)}`, '');
    };
    /**
     * 获取时间窗口设置详情
     */
    export var GetTimeWDDetail = (id: any): Promise<any> => {
        return Get(`/msls/AppointmentTime/GetDetail/${id}`, {});
    };
    /**
     *  新增时间窗口设置
     */
    export var AddTimeWD = (body: any): Promise<any> => {
        return Post(`/msls/AppointmentTime/Add`, body);
    };
    /**
     * 编辑时间窗口设置
     */
    export var EditTimeWD = (id: any, body: any): Promise<any> => {
        return Put(`/msls/AppointmentTime/Save/${id}`, body);
    };

}
